// extracted by mini-css-extract-plugin
export var closeButton = "_ph-2";
export var closeButtonIcon = "_ph-3";
export var lightboxContent = "_ph-1";
export var lightboxOverlay = "_ph-0";